import { render, staticRenderFns } from "./ImpiantiDetails.vue?vue&type=template&id=53ee8556&scoped=true"
import script from "./ImpiantiDetails.vue?vue&type=script&lang=js"
export * from "./ImpiantiDetails.vue?vue&type=script&lang=js"
import style0 from "./ImpiantiDetails.vue?vue&type=style&index=0&id=53ee8556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ee8556",
  null
  
)

export default component.exports